<div class="confidentiality-container">
  <div class="dialog-header">
    <h2 style="font-size: 1.1vw;">Confidentiality Acknowledgement</h2>
  </div>
  
  <div class="dialog-content">
    <p>
      All information displayed in your profile — including your grades, salary details, and any other personal or organizational data — is strictly confidential. Sharing or disclosing this information is a violation of the Company's Code of Business Ethics (CoBE).
    </p>
    
    <p>
      By proceeding, you acknowledge your responsibility to maintain confidentiality. Any breach may result in disciplinary action.
    </p>
  </div>
  
  <div class="dialog-footer">
    <div style="flex:1">
      <label style="display: flex; align-items: center; gap: 8px; font-size: 0.95vw;">
        <input type="checkbox" [(ngModel)]="dontShowAgain" style="cursor: pointer; accent-color:#60259e;" class="dontshowmecheckbox"/>
        <span class="dontshowmelabeltext">Don't show me again</span>
      </label>
    </div>
    <button style="font-size: 1.1vw;" class="btn btn-primary" (click)="onOK()">OK</button>
  </div>
</div>
